// extracted by mini-css-extract-plugin
export var typingIndicator = "_q4-0";